import { makeAutoObservable } from "mobx";
import { RootStore } from "../Store";
import { DivisionsStore } from "./division/DivisionsStore";
import { RegionsStore } from "./region/RegionsStore";

export class AdminStore {
  rootStore: RootStore;

  divisionStore: DivisionsStore;
  regionsStore: RegionsStore;

  constructor(rootStore: RootStore) {
    makeAutoObservable(this, {
      rootStore: false,
    });
    this.rootStore = rootStore;
    this.divisionStore = new DivisionsStore(this);
    this.regionsStore = new RegionsStore(this);
  }
}
